import { gql } from '@apollo/client';

export const FETCH_EXPOSURE_SUMMARY = gql`
  query GetExposureSummary($filter: ExposureSummaryInput!) {
    exposureSummary(filter: $filter) {
      uuid
      locationName
      directRevenueSupported
      indirectRevenueSupported
      totalRevenueSupported
      rebuildTime
      mitigation
      mitigationPercentage
      netRevenueExposure
      unmitigatedRevenue
      finishedGoodsInventory
      internalMitigation
      externalMitigation
      finishedGoodsInventoryPercentage
      internalMitigationPercentage
      externalMitigationPercentage
    }
  }
`;

export const FETCH_PROCESS_AREA_EXPOSURE_SUMMARY = gql`
  query ProcessAreaExposureSummary($filter: ProcessAreaExposureSummaryInput) {
    processAreaExposureSummary(filter: $filter) {
      annualRevenueSupported
      bcpStatus
      externalMitigation
      externalMitigationPercentage
      finishedGoodsInventory
      finishedGoodsInventoryPercentage
      internalMitigation
      internalMitigationPercentage
      locationName
      name
      rebuildTime
      residualRevenueExposure
      totalMitigation
      totalMitigationPercentage
      totalRevenueExposure
      uuid
    }
  }
`;

export const FETCH_PROCESS_EXPOSURE_SUMMARY = gql`
  query ProcessExposureSummary($filter: ProcessAreaExposureSummaryInput) {
    processExposureSummary(filter: $filter) {
      annualRevenueSupported
      bcpStatus
      externalMitigation
      externalMitigationPercentage
      finishedGoodsInventory
      finishedGoodsInventoryPercentage
      internalMitigation
      internalMitigationPercentage
      locationName
      name
      rebuildTime
      residualRevenueExposure
      totalMitigation
      totalMitigationPercentage
      totalRevenueExposure
      uuid
    }
  }
`;

export const FETCH_SUPPLIER_SUMMARY = gql`
  query GetSummaryDependencyFilter($filter: SupplierSummaryFilterInput!) {
    getSupplierDependenciesSummary(filter: $filter) {
      uuid
      availableAlternatives
      bcpUpdatedAt
      sourcingStatus
      supplierName
      qualifiedAlternatives
      bcpUploaded
      totalRevenueSupported
    }
  }
`;

// export const FILTER_SUPPLIER_SUMMARY = gql`
//   query GetSummaryDependencyFilter($filter: SupplierSummaryFilterInput!) {
//     getSupplierDependenciesSummary(filter: $filter) {
//       uuid
//       supplierName
//       sourcingStatus
//       availableAlternatives
//       qualifiedAlternatives
//       bcpUploaded
//       bcpUpdatedAt
//     }
//   }
// `;
